/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/feePercentFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoFeeField implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = "E";
        scope = {
            currentValue: "=ngModel",
            isPercent: "=",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired"
        };

        templateUrl = "app/components/controls/feeFieldTemplate.html";

        constructor(private $filter: angular.IFilterService) { 
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var filter = this.$filter;
            //scope.isPercent = true;
            scope.startValue = scope.currentValue;

            scope.$watch('currentValue', currentVal => {

                if (currentVal > 1000 && scope.filter === "currency") {
                    scope.isToLarge = true
                    currentVal = 1000;
                }
                else if (currentVal > 100 && scope.filter === "meevoFeePercent") {
                    scope.isToLarge = true;
                    currentVal = 100;
                }
                else {
                    scope.isToLarge = false;
                }

                var newMaskedVal = filter(scope.filter)(currentVal);

                if (scope.maskedValue !== newMaskedVal) {
                    scope.maskedValue = newMaskedVal;
                }
            });
            scope.$watch('isPercent', filterSwitch => {
                if (scope.isPercent) {
                    scope.filter = "meevoFeePercent";
                    if (scope.startValue != null) {

                        scope.maskedValue = filter(scope.filter)(scope.startValue);
                        scope.startValue = null;
                    }
                    else {
                        scope.maskedValue = "000.000%";
                    }
                }
                else {
                    scope.filter = "currency";
                    if (scope.startValue != null) {
                        scope.maskedValue = filter(scope.filter)(scope.startValue);
                        scope.startValue = null;
                    }
                    else{
                        scope.maskedValue = "$ 00.00";
                    }
                }
            });

            scope.$watch('maskedValue', maskedVal => {
                if (scope.maskedValue) {
                    //var newUnmaskedVal = parseFloat(scope.maskedValue.replace(/[^0-9\.]/g, ''));
                    if (typeof scope.maskedValue === 'string') {
                        var newUnmaskedVal = parseFloat(scope.maskedValue.replace(/[^0-9\.]/g, ''));
                    }
                    else {
                        var newUnmaskedVal = parseFloat(scope.maskedValue);
                    }
                    //back here newUnmaskedVal

                    if (scope.currentValue !== "") {
                        if (typeof scope.currentValue === 'string') {
                            var tempcurrentValue = parseFloat(scope.currentValue.replace(/[^0-9\.]/g, ''));
                        }
                        else {
                            var tempcurrentValue = parseFloat(scope.currentValue);
                        }
                        
                    } 

                    if (tempcurrentValue !== newUnmaskedVal) {
                        scope.currentValue = newUnmaskedVal.toString();
                    }

                } else {
                    scope.currentValue = "";
                }
            });

            element.on("click", (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

            element.on("keydown", (event: JQueryEventObject) => {
                if (_.contains([46, 8, 9, 27, 13, 110, 190], event.keyCode) ||
                    // Allow: Ctrl+A
                    (event.keyCode === 65 && event.ctrlKey) ||
                    // Allow: Ctrl+C
                    (event.keyCode === 67 && event.ctrlKey) ||
                    // Allow: Ctrl+X
                    (event.keyCode === 88 && event.ctrlKey) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39)) {
                    // let it happen, don't do anything 
                    return;
                }

                if (scope.currentValue && scope.currentValue.length == 10) { // limit size of phone number, should be a variable; currently only supports US format.
                    return false;
                }

                // Ensure that it is a number and stop the keypress
                if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }

                return true;
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter) => {
                return new MeevoFeeField($filter);
            };

            directive.$inject = ["$filter"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoFeeField", MeevoFeeField.factory());
}